import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SFPalette } from '@/lib/color';
import Typography from '@mui/material/Typography';
import DangerouslySetInnerHTML from '@/lib/DangerouslySetInnerHTML';
import { boardDetail, boardDetailProps, resBoardDetail } from '@/api/server/board/read';
import ErrorRes from '@/api/server/ErrorRes';

export default function EventDetail() {
  const navigate = useNavigate();
  const { path } = useParams();
  const [view, setView] = useState<resBoardDetail>();
  // const fileList = useRef([]);
  useEffect(() => {
    if (!path) {
      alert('존재하지 않습니다.');
      navigate(-1);
      return;
    }
    (async () => {
      const id = path;
      const type = 'event' as const;
      const paylaod: boardDetailProps = {
        board_type: type,
        board_id: id,
      };
      const re = await boardDetail(paylaod);
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setView(re.data.postMap);
      // fileList.current = re.data.fileList;
    })();
    return () => {};
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      {view && (
        <>
          <TopBackButton
            title={view.title}
            boxProps={{
              mb: 4,
            }}
          />
          <DangerouslySetInnerHTML
            html={{
              __html: view.post,
            }}
          />
        </>
      )}
    </Container>
  );
}
